import { render, staticRenderFns } from "./DashInsightCard.vue?vue&type=template&id=8b71c2a2&"
import script from "./DashInsightCard.vue?vue&type=script&lang=js&"
export * from "./DashInsightCard.vue?vue&type=script&lang=js&"
import style0 from "./DashInsightCard.vue?vue&type=style&index=0&id=8b71c2a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports